/** Extract position book meta fields from API response. */
export function extractBookMetaSummary(data) {
  if (!data || typeof data !== "object") return null;

  const hasMeta =
    data.total_accounts != null ||
    data.realised_pnl != null ||
    data.unrealised_pnl != null ||
    data.total_pnl != null;

  if (!hasMeta) return null;

  return {
    totalAccounts: data.total_accounts,
    realisedPnl: data.realised_pnl,
    unrealisedPnl: data.unrealised_pnl,
    totalPnl: data.total_pnl,
  };
}

/** Extract holding book meta fields from API response. */
export function extractHoldingBookMetaSummary(data) {
  if (!data || typeof data !== "object") return null;

  const hasMeta =
    data.total_accounts != null ||
    data.current_value != null ||
    data.invested != null ||
    data.pnl != null;

  if (!hasMeta) return null;

  return {
    totalAccounts: data.total_accounts,
    currentValue: data.current_value,
    invested: data.invested,
    pnl: data.pnl,
    pnlPercentage: data.pnl_percentage,
  };
}

export function formatBookMetaCount(value) {
  if (value == null || Number.isNaN(Number(value))) return "—";
  return Number(value).toLocaleString("en-IN");
}

export function formatBookMetaPnl(value) {
  if (value == null || Number.isNaN(Number(value))) return "—";
  const n = Number(value);
  const formatted = Math.abs(n).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  if (n > 0) return `+${formatted}`;
  if (n < 0) return `-${formatted}`;
  return formatted;
}

export function bookMetaPnlTone(value) {
  const n = Number(value);
  if (Number.isNaN(n) || n === 0) return "neutral";
  return n > 0 ? "positive" : "negative";
}
